import React from 'react';
import { createComponent } from '@lit/react';
import { SDSCard } from '../sds-card/sds-card';

export const SDSCardWrapper = createComponent({
	tagName: 'sds-card',
	elementClass: SDSCard,
	react: React,
	events: {},
});
